const config = {
  productionURL: process.env.REACT_APP_PRODUCTION_URL,
  developmentURL: process.env.REACT_APP_DEVELOPMENT_URL,
  guestEmail: process.env.REACT_APP_GUEST_EMAIL,
  guestPassword: process.env.REACT_APP_GUEST_PASSWORD,
};

export default config;
